/**
 * Validate Passwords
 *
 * @param value
 * @param allValues
 */
export const passwordValidation = (value, allValues) => {
    if (!value) {
        return 'Password is required';
    }
    if (value && value.toString().length < 10) {
        return 'Password must be at least 10 characters';
    }
    const pw = allValues.sys_password;
    const cpw = allValues.sys_confirm_password;
    if ((pw && cpw) && (pw !== cpw)) {
        return 'Passwords must be the same';
    }
    return null;
};

/**
 * Validate Changed Passwords
 *
 * @param value
 * @param allValues
 */
export const passwordChangeValidation = (value, allValues) => {
    if (value && value.toString().length < 10) {
        return 'Password must be at least 10 characters';
    }
    const pw = allValues.sys_new_password;
    const cpw = allValues.sys_confirm_new_password;
    if ((pw || cpw) && (pw !== cpw)) {
        return 'Passwords must be the same';
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/validation.js